import {
  createPublicClient,
  fallback,
  http,
} from "viem";

import { ACTIVE_CHAIN, RPC_URLS } from "@/config/chain";

/**
 * Build the read client. The concrete return type carries `ACTIVE_CHAIN`'s
 * formatters (Base is OP-stack, so blocks/txs include the `deposit` type),
 * which is why we infer it rather than annotate the loose `PublicClient`.
 */
const createReadClient = () =>
  createPublicClient({
    chain: ACTIVE_CHAIN,
    transport: fallback(
      RPC_URLS.map((url) => http(url, { batch: true, retryCount: 1 })),
      { rank: false, retryCount: 1 },
    ),
    batch: { multicall: { wait: 32 } },
  });

let cached: ReturnType<typeof createReadClient> | null = null;

/**
 * Singleton public client used for all read calls.
 *
 * - `batch.multicall` collapses any `readContract` calls issued within a
 *   ~32 ms window into a single Multicall3 RPC request.
 * - `fallback(...)` rotates through several free Base endpoints; if one is
 *   rate-limiting or down, viem moves to the next. We retry per-transport.
 */
export const buildPublicClient = () => {
  if (cached) return cached;
  cached = createReadClient();
  return cached;
};
